<template>
    <div :class="`questionnaire ${isShowLogin || isShowOs ? 'blur' : ''} ${isShow}`">
        <!-- 页面标题 -->
        <div v-wechat-title="is_reward ? '《最强蜗牛》测试回馈礼' : '《最强蜗牛》测试调研问卷'"></div>

        <!-- 头部 -->
        <div :class="['header', user_info.role_id ? 'true' : '', popup.question ? 'question': '']">
            <div class="official-btn" @click="goLink('https://snail.qingcigame.com/', '最强蜗牛_新手测试返利_点击前往官网')"></div>
            <div class="account">{{ user_info.role_id ? `${user_info.role_name} ${user_info.server_name ? `[${user_info.server_name}]` : ''}` : '请先登录' }}</div>
            <div :class="['user-btn', user_info.platform === 'android' || user_info.platform === 'ios' ? 'change' : '' ]" @click="userBtn()"></div>
        </div>

        <div class="swiper1">
            <div class="swiper-wrapper">
                <div class="swiper-slide swiper2">
                    <div class="swiper-wrapper">
                        <div :class="`swiper-slide ${join_text}`">
                            <!-- 主页面 -->
                            <div class="test-rule" @click="handlePopup({ name: 'testRule', status: true})"></div>
                            <div class="test-time">{{ test_time }}</div>
                            <div :class="`test-btn status-${test_reward.status}`" @click="reward(test_reward)"></div>
                            <div class="question-rule" @click="handlePopup({ name: 'questionRule', status: true})"></div>
                            <div class="question-time">{{ question_time }}</div>
                            <div :class="`question-btn ${is_write}`" @click="questionBtn()"></div>
                            <div :class="`reward-btn status-${question_reward.status}`" @click="reward(question_reward)"></div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide footer">
                    <!-- 底栏 -->
                    <Footer :gameName="gameName"></Footer>
                </div>
            </div>
        </div>

        <!-- 弹窗 -->
        <div :class="`popupWrap ${ratio}`">
            <!-- 测试奖励领取规则 -->
            <div :class="`popup testRule ${popup.testRule}`" @click.self="handlePopup({ name: 'testRule', status: false})">
                <div class="popup-main"></div>
            </div>

            <!-- 调研奖励领取规则 -->
            <div :class="`popup questionRule ${popup.questionRule}`" @click.self="handlePopup({ name: 'questionRule', status: false})">
                <div class="popup-main">
                    <div class="wrap">
                        <div class="inner"></div>
                    </div>
                </div>
            </div>

            <!-- 领取角色确认 -->
            <div :class="`popup confirm ${popup.confirm}`" @click.self="handlePopup({ name: 'confirm', status: false})">
                <div class="popup-main">
                    <span>{{ user_info.role_name }}</span>
                    <span>{{ user_info.server_name }}</span>
                    <div class="change-btn" @click="handlePopup({ name: 'os', status: true})"></div>
                    <div class="reward-btn" @click="onReward()"></div>
                </div>
            </div>

            <!-- 问卷 -->
            <div :class="`popup question ${popup.question}`">
                <div class="question-main">
                    <div class="board">
                        <!-- 题目 -->
                        <div class="wrap" v-for="item in question" :key="item.id" v-show="!is_write && item.id == questionIndex">
                            <div class="title">
                                {{ `${item.id}、` }}
                                <span>{{ `${item.must ? '[必填]' : ''}` }}</span>
                                {{ `${item.title}【${item.options.length ? (item.type ? '多选' : '单选') : '填空'}】` }}
                            </div>
                            <!-- 选项题 -->
                            <div class="options" v-if="item.options.length">
                                <div :class="`item ${answer[questionIndex - 1].hasOwnProperty(indexB + 1) ? 'true' : ''}`" v-for="(itemB, indexB) in item.options" :key="indexB">
                                    <span class="text" @click="handleAnswer(indexB)">{{ itemB ? itemB : '其他(请注明)：'}}</span>
                                    <input type="text" v-if="!itemB" v-model="answer[questionIndex - 1][indexB + 1]" @input="onInput()" @focus="isFocus = true" @blur="isFocus = false">
                                </div>
                            </div>
                            <!-- 填空题 -->
                            <div class="input" v-else>
                                <textarea v-model="answer[questionIndex - 1][1]"  maxlength="300" @focus="isFocus = true" @blur="isFocus = false"></textarea>
                                <div :class="`num num-${answer[questionIndex - 1][1] ? answer[questionIndex - 1][1].length : 0}`"><span>{{ answer[questionIndex - 1][1] ? answer[questionIndex - 1][1].length : 0 }}</span>/300</div>
                            </div>
                        </div>
                        <div class="prev-btn" v-show="!is_write && questionIndex !== 1" @click="handleQuestion('prev')"></div>
                        <div :class="`next-btn ${questionIndex === question.length} id-${questionIndex}`" v-show="!is_write" @click="handleQuestion('next')"></div>
                        <!-- 百分比 -->
                        <div class="progress" v-show="!is_write" :style="{'--progress': `${Math.floor((this.questionIndex - 1) / this.question.length * 100)}%`}">
                            <div class="inner"></div>
                            <div class="num">{{ `${Math.floor((this.questionIndex - 1) / this.question.length * 100)}%` }}</div>
                        </div>
                        <!-- 结束页 -->
                        <div class="end" v-show="is_write">
                            <div class="text"><span>您已完成本次问卷</span><span>感谢您对《最强蜗牛》的帮助与支持</span></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 防抖遮罩 -->
            <div :class="`popup mask ${popup.mask}`"></div>
        </div>

        <!-- 登录弹窗 -->
        <Login v-if='isShowLogin' v-on:channelCallback='onInit' :gameName="gameName" :loginTypes='loginTypes' :downloadUrl='downloadUrl' channelTips='角色UID可在游戏中—设置—UID查看' noAuthLogin></Login>

        <!-- 绑定弹窗 -->
        <Os v-if='isShowOs' v-on:selectCallback='onInit' v-on:logoutCallback='osCancel' :gameName='gameName'></Os>
    </div>
</template>

<script>
import Vue from "vue"
import { Toast } from "mint-ui"
import { mapState, mapMutations, mapActions } from "vuex"
import { getTimeStamp, buriedLogger, analysisParams } from "@/utils/utils"
import Login from "@/components/login"
import Os from "@/components/os"
import Footer from '@/components/Footer'
import { onInitAPI, onInfoAPI, onLogoutAPI, onQuestionAPI, onRewardAPI, onAutoAPI } from "../api"
import { swiper } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
    name: 'questionnaire',
    data () {
        return {
            gameName: 'snail',
            loginTypes: ['sms', 'password'],
            downloadUrl: 'https://snail.qingcigame.com/',
            ratio: null, // 屏幕比例
            isShow: false, // 是否展示页面
            question: [
                {id: 1, title: '您之前玩过《最强蜗牛》吗？', type: 0, options: ['是全新玩家', '是回归玩家，之前有玩过', '是老玩家，一直都在玩'], must: true, jump: [2,5,5]}, // type: 0单选，1多选；options：无选项表示填空，选项为''表示其他（填空）；must：是否必填；jump：下一题id；conflict：冲突选项索引
                {id: 2, title: '在游戏前期，您觉得指引清晰易懂吗？', type: 0, options: ['非常清楚，完全理解', '比较清楚，基本理解', '有些模糊，部分不明白', '完全不清楚，难以理解'], must: true, jump: [3,3,3,3]},
                {id: 3, title: '现在的新手指引，可以帮助您了解游戏的全部基本操作吗？', type: 0, options: ['是，非常有帮助', '一般，有一定帮助', '否，几乎没有帮助'], must: true, jump: [6,4,4]},
                {id: 4, title: '在游戏前期，您对哪些游戏操作存在过困惑？', type: 0, options: [], must: true, jump: [6]},
                {id: 5, title: '再次游玩新手指引时，会给您产生较大的操作负担吗？', type: 0, options: ['会，不想再重新玩一遍了', '还好，在接受范围之内', '不会，了解新内容需要指引'], must: true, jump: [6,6,6]},
                {id: 6, title: '您认为，前期国家探索中，哪些玩法比较吸引人？', type: 1, options: ['探索推图节奏很顺畅', '探索的目标感很强', '探索手册的指引性很好', '探索的奖励丰富，主角可快速得到成长反馈', '没什么吸引人的', ''], must: true, jump: [7,7,7,7,7,7], conflict: 4},
                {id: 7, title: '您觉得前期国家探索有什么不好的感受体验？', type: 1, options: ['探索推图节奏很差', '故事内容平淡', '探索目标分散，不知道要做什么', '探索没什么反馈感，也没有什么提升', '没什么不好的体验', ''], must: true, jump: [8,8,8,8,8,8], conflict: 4},
                {id: 8, title: '您认为前期玩法中最有吸引力的系统是什么？', type: 1, options: ['国家探索', '器官培养', '贵重品收集', '故事剧情', '家园解锁与建设', ''], must: true, jump: [9,9,9,9,9,9]},
                {id: 9, title: '您觉得器官玩法有哪些吸引人的？', type: 1, options: ['器官可变化主角外形', '器官技能效果多样', '器官培养感很强', '器官对战力提升很明显', '没什么吸引人的', ''], must: true, jump: [10,10,10,10,10,10], conflict: 4},
                {id: 10, title: '您觉得新器官玩法有什么不好的感受体验？', type: 1, options: ['信息量太大，上手较难', '器官培养缓慢', '分散前期目标，太多系统需要追求培养', '器官作用不强', '没什么不好的体验', ''], must: true, jump: [11,11,11,11,11,11], conflict: 4},
                {id: 11, title: '您对本次删档测试期间的整体游戏体验如何评价？', type: 0, options: [], must: false, jump: [12]},
                {id: 12, title: '若有任何宝贵的意见和建议，欢迎在此留下~', type: 0, options: [], must: false}
            ],
            answer: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}], // 回答
            answerWay: [], // 回答路线
            questionIndex: 1, // 当前问题索引
            reward_id: null, // 领奖id
            isFocus: false, // 是否获取焦点
            popup: {
                testRule: false, // 测试奖励领取规则
                questionRule: false, // 调研奖励领取规则
                confirm: false, // 确认
                question: false, // 问卷
                mask: false, // 防抖遮罩
                popup: false, // 开启弹窗
            },
            user_info: {}, // 用户信息
            is_reward: false, // 是否为奖励发放期
            is_write: false, // 是否填写问卷
            join_text: false, // 是否为受众账号
            test_reward: {}, // 测试奖励
            question_reward: {}, // 问卷奖励
            test_time: '', // 测试奖励时间
            question_time: '', // 问卷奖励时间
        }
    },
    components: { Login, Os, Footer, swiper },
    computed: {...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs'])},
    created() {
        if (!global.consoleSwitch) console.log = () => {}
        window.addEventListener("pageshow", this.resize)
        window.addEventListener("resize", this.resize)
        // 清空store上的用户数据
        this.setInitActiveInfo()
        this.setInitUserInfo()
        // 埋点
        const bl = buriedLogger('snail', '最强蜗牛_新手测试返利')
        this.logger = bl
        setTimeout(() => { this.logger.sum('最强蜗牛_新手测试返利_访问活动页') }, 200)
    },
    watch: {
        isShowOs: {
            handler(newValue, oldValue) {
                if (newValue) {
                    this.osReward = Date.now()
                } else {
                    if (Date.now() - this.osReward < 300) this.handlePopup({name: 'login', status: true})
                }
            }
        }
    },
    mounted() {
        this.onAuto()
        this.onInit(true)
    },
    methods: {
        // 自适应
        resize() {
            setTimeout(() => {
                if (window.innerWidth < 540) {
                    if (this.isFocus) return
                    const ratio = window.innerWidth / window.innerHeight
                    if (ratio > 320 / 480) {
                        this.ratio = 'ratio1'
                    } else if (ratio > 320 / 530) {
                        this.ratio = 'ratio2'
                    } else if (ratio > 320 / 570) {
                        this.ratio = 'ratio3'
                    } else {
                        this.ratio = ''
                    }
                } else {
                    document.documentElement.style.fontSize = '54px'
                }
                this.swiperInit()
            }, 320)
        },
        // 控制弹窗
        handlePopup({name, status}) {
            if (name === 'login') {
                this.changeLoginPopup(true)
                this.logger.sum('最强蜗牛_新手测试返利_打开登录弹窗')
            } else if (name === 'os') {
                this.changeOsPopup(true)
                this.logger.sum('最强蜗牛_新手测试返利_点击切换角色按钮')
            } else {
                this.popup[name] = status
                this.popup.popup = status
                if (status) {
                    switch (name) {
                        case 'testRule':
                            this.logger.sum('最强蜗牛_新手测试返利_打开测试奖励领取规则弹窗')
                            break
                        case 'questionRule':
                            this.logger.sum('最强蜗牛_新手测试返利_打开调研奖励领取规则弹窗')
                            break
                        case 'confirm':
                            this.logger.sum('最强蜗牛_新手测试返利_打开领取角色确认弹窗')
                            break
                        case 'question':
                            this.logger.sum('最强蜗牛_新手测试返利_打开问卷页')
                            break
                    }
                }
            }
        },
        // 登录校验
        checkLogin() {
            if (!this.user_info.role_id) {
                this.onToast('请先登录')
                this.handlePopup({name: 'login', status: true})
                return false
            }
            return true
        },
        // 免登录
        onAuto() {
            const { sign, role_id, token, zone, game_id, web_bonus_id, server_id, os } = analysisParams(location.href)
            if (sign || role_id || token || zone || game_id || web_bonus_id || server_id || os) onAutoAPI({ sign, role_id, token, zone, game_id, web_bonus_id, server_id, os }).then(() => { location.href = 'https://h5.qingcigame.com/snail/questionnaire/enter{timestamp}' })
        },
        // 初始化
        onInit(firstEnter) {
            onInitAPI().then((response) => {
                if (Number(response.code) === 200) {
                    this.onInitDataCallback(response)
                    this.setUserInfo(response.data.user_info)
                    this.user_info = response.data.user_info
                    this.is_reward = response.data.activity.is_reward
                    this.is_write = response.data.activity.is_write
                    this.test_reward = response.data.activity.reward_list[0]
                    this.question_reward = response.data.activity.reward_list[1]
                    this.test_time = this.handleTransform(this.test_reward)
                    this.question_time = this.handleTransform(this.question_reward)
                    this.join_text = response.data.activity.join_text
                    if (!this.join_text) {
                        this.osCancel()
                        this.logger.sum('最强蜗牛_新手测试返利_登录非受众账号')
                        setTimeout(() => {this.onToast('该账号非本次活动受众用户')}, 300)
                    }
                    return
                }
                Number(response.code) !== 401 && this.onToast(response.message)
            }).finally(() => {
                if (firstEnter) this.onInfo()
            })
        },
        // 时间转文本
        handleTransform(obj) {
            return obj.ctreated && obj.end_time ? `领取时间：${obj.ctreated.replaceAll('-', '.').slice(0, -3)}~${obj.end_time.replaceAll('-', '.').slice(5, -3)}` : ''
        },
        // 未登录信息
        onInfo() {
            onInfoAPI().then((response) => {
                if (Number(response.code) === 200) {
                    this.is_reward = response.data.is_reward
                    this.isSetShare()
                    this.handlePopup({name: 'question', status: !this.is_reward})
                    if (!this.user_info.role_id) this.handlePopup({name: 'login', status: true})
                    this.isShow = true
                    return
                }
                this.onToast(response.message)
            })
        },
        // 轮播初始化
        swiperInit() {
            this.$nextTick(() => {
                if (this.swiper1 && this.swiper1.destroy) this.swiper1.destroy()
                this.swiper1 = new Swiper('.swiper1', {
                    direction: 'vertical',
                    slidesPerView: 'auto',
                    resistanceRatio: 0,
                    longSwipesRatio: 0.1, // 最小拖动距离比例
                    onReachBeginning: function() {
                        document.querySelector('.swiper2').style.pointerEvents = 'auto'
                    },
                    onReachEnd: function() {
                        document.querySelector('.swiper2').style.pointerEvents = 'none'
                    }
                })
                if (this.swiper2 && this.swiper2.destroy) this.swiper2.destroy()
                this.swiper2 = new Swiper('.swiper2', {
                    direction: 'vertical',
                    slidesPerView: 'auto',
                    resistanceRatio: 0,
                    nested: true,  // 切换子swiper时停止父swiper的切换
                    freeMode: 'true',
                    freeModeMomentumBounce: false, // 禁止惯性回弹
                    mousewheelControl: true, // 开启鼠标滚轮滑动
                })
            })
        },
        // 填写问卷按钮
        questionBtn() {
            if (!this.is_write) {
                this.logger.sum('最强蜗牛_新手测试返利_点击填写问卷按钮')
                this.handlePopup({name: 'question', status: true})
            }
        },
        // 切换题目
        handleQuestion(change) {
            if (change === 'prev') {
                // 上一题
                if (this.questionIndex > 1) {
                    this.questionIndex = this.answerWay[this.answerWay.length -1]
                    this.answerWay.pop() // 移除路线
                }
            } else {
                // 下一题 || 提交
                const must = this.question[this.questionIndex - 1].must // 是否必选
                const type = this.question[this.questionIndex - 1].type // 是否多选
                const index = type ? 1 : (Object.keys(this.answer[this.questionIndex - 1])[0] ? Object.keys(this.answer[this.questionIndex - 1])[0] : 1) // 回答的id
                if (must) {
                    const keys = Object.keys(this.answer[this.questionIndex - 1]).length // 是否已选
                    if (keys) {
                        const values = Object.values(this.answer[this.questionIndex - 1]).length === Object.values(this.answer[this.questionIndex - 1]).filter(item => item).length // 是否已填写
                        if (values) {
                            this.answerWay.push(this.questionIndex) // 记录路线
                            this.questionIndex === this.question.length ? this.submit() : this.questionIndex = this.question[this.questionIndex - 1].jump[index - 1]
                        } else {
                            type ? this.onToast('请在"其他"后横线部分注明原由') : this.onToast('请按当前题目顺序填写问卷')
                        }
                    } else {
                        this.onToast('请按当前题目顺序填写问卷')
                    }
                } else {
                    this.answerWay.push(this.questionIndex) // 记录路线
                    this.questionIndex === this.question.length ? this.submit() : this.questionIndex = this.question[this.questionIndex - 1].jump[index - 1]
                }
            }
        },
        // 选择选项
        handleAnswer(answerIndex) {
            if (!this.question[this.questionIndex - 1].must || this.question[this.questionIndex - 1].type) {
                // 非必选题或多选题
                let obj = this.answer[this.questionIndex - 1]
                if (obj.hasOwnProperty(answerIndex + 1)) {
                    // 取消
                    delete obj[answerIndex + 1]
                } else {
                    // 选中
                    if (answerIndex === this.question[this.questionIndex - 1].conflict) {
                        // 选择冲突选项
                        obj = {}
                    } else {
                        // 选择非冲突选项
                        delete obj[this.question[this.questionIndex - 1].conflict + 1]
                    }
                    obj[answerIndex + 1] = this.question[this.questionIndex - 1].options[answerIndex]
                }
                this.$set(this.answer, this.questionIndex - 1, obj)
            } else {
                // 单选题
                const obj = {}
                obj[answerIndex + 1] = this.question[this.questionIndex - 1].options[answerIndex]
                this.$set(this.answer, this.questionIndex - 1, obj)
            }
        },
        // 提交问卷
        submit() {
            const data = (id) => this.answerWay.includes(id) && Object.values(this.answer[id - 1]).join(' & ') ? Object.values(this.answer[id - 1]).join(' & ') : undefined
            if (!data(12) && this.question[this.questionIndex - 1].must) return this.onToast('请按当前题目顺序填写问卷')
            onQuestionAPI({
                content_one: data(1),
                content_two: data(2),
                content_three: data(3),
                content_four: data(4),
                content_five: data(5),
                content_sex: data(6),
                content_seven: data(7),
                content_eight: data(8),
                content_nine: data(9),
                content_ten: data(10),
                content_eleven: data(11),
                content_twelve: data(12)
            }).then((response) => {
                if (Number(response.code) === 200) {
                    if (this.is_reward) {
                        this.swiper2.setWrapperTranslate(window.innerHeight - document.querySelector('.swiper2 .swiper-slide-active').clientHeight + 10)
                        this.handlePopup({name: 'question', status: false})
                        setTimeout(() => {
                            this.onInit()
                            this.questionIndex = 1
                        }, 500)
                    } else {
                        this.onInit()
                    }
                    this.logger.sum('最强蜗牛_新手测试返利_问卷提交成功')
                }
                this.onToast(response.message)
            })
        },
        // 响应监测
        onInput() {
            this.$set(this.answer, this.questionIndex - 1, this.answer[this.questionIndex - 1])
        },
        // 领奖按钮
        reward(obj) {
            if (obj.status === 1) {
                // 可领取
                this.reward_id = obj.id
                this.handlePopup({name: 'confirm', status: true})
            } else {
                if (obj.id === 2) {
                    this.logger.sum('最强蜗牛_新手测试返利_问卷板块点击置灰状态"领取奖励"按钮')
                    if (obj.status === 0) this.onToast('请先填写问卷后再领取奖励')
                }
                if (obj.status === 2) this.onToast('您已领取奖励')
            }
        },
        // 领取奖励
        onReward() {
            this.logger.sum('最强蜗牛_新手测试返利_点击确认领取奖励按钮')
            onRewardAPI({
                reward_id: this.reward_id
            }).then((response) => {
                if (Number(response.code) === 200) {
                    this.onInit()
                    this.handlePopup({name: 'confirm', status: false})
                    this.reward_id === 1 ? this.logger.sum('最强蜗牛_新手测试返利_领取参与测试奖励') : this.logger.sum('最强蜗牛_新手测试返利_领取问卷填写奖励')
                }
                this.onToast(response.message)
            })
        },
        // 登录/切换/注销
        userBtn() {
            const channel = this.user_info.platform
            if (channel) {
                channel === 'android' || channel === 'ios' ? this.changeOsPopup(true) : this.osCancel()
            } else {
                this.handlePopup({name: 'login', status: true})
            }
        },
        // 注销
        osCancel() {
            onLogoutAPI({
                game_id: this.user_info.game_id
            }).then((response) => {
                if (Number(response.code) === 200) {
                    this.setInitUserInfo()
                    this.user_info = {}
                    this.handlePopup({name: 'login', status: true})
                    this.handlePopup({name: 'confirm', status: false})
                    this.answer = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
                    this.answerWay = []
                    this.questionIndex = 1
                    this.reward_id = null
                    this.user_info = {}
                    this.is_write = false
                    this.join_text = false
                    this.test_reward = {}
                    this.question_reward = {}
                    return
                }
                this.onToast(response.message)
            })
        },
        // 微信分享
        isSetShare() {
            const title = this.is_reward ? '《最强蜗牛》测试回馈礼' : '《最强蜗牛》测试调研问卷'
            this.setShare({
                link: `https://h5.qingcigame.com/snail/questionnaire/enter${getTimeStamp()}`,
                title,
                imgUrl: 'https://download4.qcplay.com/qcgame-api/c5RYqgXFjooSOnluqvwfkmSbhA51KnNBdXMad9RE.png',
                desc: '注意，仅参加过该测试的玩家可领取哦~',
            })
        },
        // TAG: 其他简易封装的方法
        onToast(config) {
            const curConfig = { duration: 1000, className: 'toasts' }
            if (!config) {
                console.error('缺少config参数')
                return false
            }
            if (typeof config === 'string') curConfig.message = config
            Toast(curConfig)
        },
        // 前往重定向
        goLink(url, loggerName) {
            if (url === '') return
            this.logger.sum(loggerName)
            setTimeout(() => { window.open(url, '_blank') }, 200)
        },
        ...mapMutations(['setUserInfo', 'changeLoginPopup', 'changeOsPopup', 'setInitActiveInfo', 'setInitUserInfo']),
        ...mapActions(['onInitDataCallback', 'setShare'])
    }
}
</script>

<style lang='less'>
@import './index.less';
</style>


// WEBPACK FOOTER //
// src/pages/snail/questionnaire/index/index.vue